<template>
    <v-list :id="gtmTrackerId">
        <v-list-item
            v-for="(filterItem, filterName, index) in filterData"
            :key="`${filterName}-${index}`"
            class="habiteo-body-2 checkbox-item"
        >
            <TextItem
                :filterType="filterType"
                :filterItem="filterItem"
                :filterName="filterName.toString()"
                @filter-method="filterBy"
            />
        </v-list-item>
    </v-list>
</template>

<script>
    import TextItem from "@/components/sidebar/cutaway/components/TextItem";

    export default {
        name: "TextItems",
        components: {
            TextItem
        },
        computed: {
            gtmTrackerId() {
                return `gtm-filter-${this.$props.filterType}`;
            }
        },
        props: {
            filterData: {
                type: [Object, Array],
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/TextItems.vue